var _rect, _ellipse, _ellipse2, _ellipse3, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictoPrivate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128,
    cy: 42.7014,
    rx: 21.3333,
    ry: 21.327,
    fill: "url(#paint0_linear_2609_1103)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 31.327,
    rx: 21.3333,
    ry: 21.327,
    fill: "url(#paint1_linear_2609_1103)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.6445,
    cy: 55.4976,
    rx: 17.7778,
    ry: 17.7725,
    fill: "url(#paint2_linear_2609_1103)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7556 160L56.8889 160H103.111L104.533 160C104.537 160 104.54 160 104.544 160H152.889C156.816 160 160 156.817 160 152.891V96.019C160 78.3511 145.673 64.0284 128 64.0284C115.936 64.0284 105.431 70.7021 99.9786 80.558C94.4502 76.0047 87.3668 73.2701 79.6444 73.2701C73.6567 73.2701 68.053 74.9142 63.2605 77.7755C60.1162 63.4088 47.3144 52.654 32 52.654C14.3269 52.654 0 66.9767 0 84.6445V152.891C0 156.817 3.18375 160 7.11111 160H54.745L54.7556 160Z",
    fill: "url(#paint3_linear_2609_1103)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2609_1103",
    x1: 128,
    y1: 21.3744,
    x2: 128,
    y2: 64.0285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC3CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2609_1103",
    x1: 32,
    y1: 10,
    x2: 32,
    y2: 52.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC3CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2609_1103",
    x1: 79.6445,
    y1: 37.7251,
    x2: 79.6445,
    y2: 73.2702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC3CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2609_1103",
    x1: 80,
    y1: 52.654,
    x2: 80,
    y2: 160,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CFFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01B69D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoPrivate);
export default __webpack_public_path__ + "static/media/picto_private.52e03d27337062dae13245f129415107.svg";
export { ForwardRef as ReactComponent };